import { useState } from "react";
import { PhoneCall, Note } from "@phosphor-icons/react";
import FirmCallLogsDialog from "@/components/FirmCallLogsDialog";
import NotesDialog from "@/components/NotesDialog";

/**
 * Inline pair of icons (Call Logs, Notes) used in firm tables.
 * Owns its own dialog state. Stops row click propagation so it can sit
 * inside a clickable `<tr>` without triggering the row navigation.
 */
export default function FirmRowActions({ firm }) {
  const [callsOpen, setCallsOpen] = useState(false);
  const [notesOpen, setNotesOpen] = useState(false);

  if (!firm) return null;

  return (
    <>
      <div className="inline-flex items-center gap-1">
        <button
          type="button"
          onClick={(e) => { e.stopPropagation(); setCallsOpen(true); }}
          title="Call logs"
          className="inline-flex items-center justify-center w-7 h-7 rounded-md text-gray-400 hover:text-violet-600 hover:bg-violet-50 transition-colors"
          data-testid={`firm-row-calls-${firm.subdomain}`}
        >
          <PhoneCall size={14} />
        </button>
        <button
          type="button"
          onClick={(e) => { e.stopPropagation(); setNotesOpen(true); }}
          title="Notes"
          className="inline-flex items-center justify-center w-7 h-7 rounded-md text-gray-400 hover:text-violet-600 hover:bg-violet-50 transition-colors"
          data-testid={`firm-row-notes-${firm.subdomain}`}
        >
          <Note size={14} />
        </button>
      </div>

      {/* Dialogs are rendered as descendants of this component which is itself
          inside the parent <tr>. Radix portals the DOM out to body, but React
          events still bubble up the React tree — so a click on the dialog's
          "Log a call" button would otherwise navigate the row to Firm 360.
          stopPropagation here keeps row-click and dialog-click separated. */}
      <div onClick={(e) => e.stopPropagation()}>
        <FirmCallLogsDialog
          open={callsOpen}
          firm={callsOpen ? firm : null}
          onClose={() => setCallsOpen(false)}
        />
        <NotesDialog
          open={notesOpen}
          firm={notesOpen ? firm : null}
          onOpenChange={(v) => setNotesOpen(v)}
        />
      </div>
    </>
  );
}
